import React from 'react';
import type { Theme } from '@mui/material';
import { radioClasses, svgIconClasses } from '@mui/material';
import type { Components } from '@mui/material/styles';
import { RadioButtonChecked, RadioButtonUnchecked } from '@mui/icons-material';

import { SIZE_LARGE, SIZE_SMALL, SIZE_X_SMALL } from '@/mui/constants';

export default function MuiRadio(theme: Theme): Components['MuiRadio'] {
  return {
    defaultProps: {
      color: 'primary',
      icon: <RadioButtonUnchecked />,
      checkedIcon: <RadioButtonChecked />,
    },
    variants: [
      {
        props: { size: SIZE_X_SMALL },
        style: {
          padding: '3px',
          fontSize: '18px',
        },
      },
      {
        props: { size: SIZE_SMALL },
        style: {
          padding: '5px',
          fontSize: '20px',
        },
      },
      {
        props: { size: SIZE_LARGE },
        style: {
          padding: '7px',
          fontSize: '28px',
        },
      },
    ],
    styleOverrides: {
      root: {
        padding: '6px',
        fontSize: '24px',

        [`& .${svgIconClasses.root}`]: {
          fontSize: 'inherit',
        },
      },
      colorNeutral: {
        color: theme.palette.shades[600],

        [`&.${radioClasses.checked}`]: {
          color: theme.palette.shades[700],
        },
        '&:hover': {
          backgroundColor: theme.palette.action.hover,
        },
        '&:focus': {
          backgroundColor: theme.palette.action.focus,
        },
      },
    },
  };
}
